// ==========================================================================
// WINTER EFFECTS - JavaScript pentru fulgi de zăpadă și cursor special
// ==========================================================================

(function() {
    'use strict';
    
    // Configurație fulgi de zăpadă
    const CONFIG = {
        snowflakeCount: 50, // Număr de fulgi
        snowflakeChars: ['❄', '❅', '❆', '✻', '✼', '❉'], // Caractere diferite pentru fulgi
        minSize: 10, // Mărime minimă (px)
        maxSize: 25, // Mărime maximă (px)
        minDuration: 10, // Durată minimă animație (secunde)
        maxDuration: 30, // Durată maximă animație (secunde)
        cursorTrail: true // Activează urmă cursor
    };
    
    // Creează container pentru fulgi
    function createSnowflakesContainer() {
        const container = document.createElement('div');
        container.className = 'snowflakes';
        container.setAttribute('aria-hidden', 'true');
        document.body.appendChild(container);
        return container;
    }
    
    // Generează un fulg aleatoriu
    function createSnowflake() {
        const snowflake = document.createElement('div');
        snowflake.className = 'snowflake';
        
        // Caracter aleatoriu pentru fulg
        const char = CONFIG.snowflakeChars[Math.floor(Math.random() * CONFIG.snowflakeChars.length)];
        snowflake.textContent = char;
        
        // Poziție orizontală aleatorie
        snowflake.style.left = Math.random() * 100 + '%';
        
        // Mărime aleatorie
        const size = CONFIG.minSize + Math.random() * (CONFIG.maxSize - CONFIG.minSize);
        snowflake.style.fontSize = size + 'px';
        
        // Durată animație aleatorie
        const duration = CONFIG.minDuration + Math.random() * (CONFIG.maxDuration - CONFIG.minDuration);
        snowflake.style.animationDuration = duration + 's';
        
        // Delay aleatoriu pentru start
        snowflake.style.animationDelay = -Math.random() * duration + 's';
        
        return snowflake;
    }
    
    // Inițializează fulgii de zăpadă
    function initSnowflakes() {
        const container = createSnowflakesContainer();
        
        for (let i = 0; i < CONFIG.snowflakeCount; i++) {
            const snowflake = createSnowflake();
            container.appendChild(snowflake);
        }
    }
    
    // Cursor trail - creează fulg la mișcarea cursorului
    let lastCursorTime = 0;
    function createCursorSnowflake(x, y) {
        const now = Date.now();
        
        // Limitează frecvența (un fulg la fiecare 100ms)
        if (now - lastCursorTime < 100) return;
        lastCursorTime = now;
        
        const snowflake = document.createElement('div');
        snowflake.className = 'cursor-snowflake';
        snowflake.textContent = CONFIG.snowflakeChars[Math.floor(Math.random() * CONFIG.snowflakeChars.length)];
        snowflake.style.left = x + 'px';
        snowflake.style.top = y + 'px';
        
        document.body.appendChild(snowflake);
        
        // Șterge fulgul după ce animația se termină
        setTimeout(() => {
            snowflake.remove();
        }, 2000);
    }
    
    // Event listener pentru cursor trail
    function initCursorTrail() {
        if (!CONFIG.cursorTrail) return;
        
        document.addEventListener('mousemove', (e) => {
            createCursorSnowflake(e.clientX, e.clientY);
        });
    }
    
    // Inițializare când DOM-ul este gata
    function init() {
        // Verifică dacă nu e mobil (pentru performanță)
        if (window.innerWidth <= 768) return;
        
        initSnowflakes();
        initCursorTrail();
    }
    
    // Așteaptă încărcarea completă a paginii
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
})();
